// _TODO: i18n
import { FunctionComponent } from 'react';
import * as vp from 'vopay';
import { useClientData } from '@/providers/ClientData.provider';
// import * as Yup from 'yup';
// import { Formik } from 'formik';
// import { useHistory } from 'react-router-dom';
// import SettingContext, { SettingCtx } from '../SettingDialogue/SettingContext';
// import SettingDialogue from '../SettingDialogue/SettingDialogue';
// import { SettingDialogueHandler, DialogueHandlerProps } from '../SettingDialogue/types';
// import { buildEditClientAccountRows } from './buildEditClientAccountRows.helper';
// import usePostEditClientAccount from '../../../../../hooks/useApi/usePostEditClientAccount';
// import usePostEnableClientAccountPortal from '../../../../../hooks/useApi/usePostEnableClientAccountPortal';
// import styles from './OverviewTabs.module.scss';
// import 'react-phone-number-input/style.css';

const { Box, Radio, Card } = vp;

// type ClientAccountType = {
//   ContactName: string;
//   EmailAddress: string;
//   PhoneNumber: string;
// };

type SettingsTabProps = {
  lang: string;
  receiveOnly?: boolean;
  // isClientAccount: boolean;
  // setIsPortalEnabled: (val: boolean) => void;
};

const SettingsTab: FunctionComponent<SettingsTabProps> = ({ lang, receiveOnly }) => {
  // const history = useHistory();
  const { response } = useClientData();
  // const [shouldShowSettingAlert, setShouldShowSettingAlert] = useState(false);
  // const [isModalVisible, setIsModalVisible] = useState(false);
  // const [isToastVisible, setIsToastVisible] = useState(false);
  // const [hasClientAccountValues, setHasClientAccountValues] = useState(false);
  // const [shouldEnablePortal, setShouldEnablePortal] = useState(false);
  // const [shouldShowToast, setShouldShowToast] = useState(false);
  // const [clientAccountValues, setClientAccountValues] = useState({
  //   EmailAddress: '',
  //   PhoneNumber: '',
  // });
  // const [editClientAccount, postEditClientAccount] = usePostEditClientAccount({});
  // const [enableClientAccountPortal, postEnableClientAccountPortal] = usePostEnableClientAccountPortal({});
  // const editClientAccountRows = buildEditClientAccountRows();

  // const settingDialogueContext: SettingCtx = {
  //   shouldShowSettingAlert,
  // };

  // Convert the phone number to E.164 number format for PhoneInput.
  // const clientAccountPhoneNumber =
  //   (account.Country === 'Canada' || account.Country === 'United States') && account.PhoneNumber.length === 10
  //     ? `+1${account.PhoneNumber}`
  //     : `+${account.PhoneNumber}`;

  // const defaultValues: ClientAccountType = {
  //   ContactName: account.BusinessName ? account.BusinessName : `${account.FirstName} ${account.LastName}`,
  //   EmailAddress: account.EmailAddress || '',
  //   PhoneNumber: clientAccountPhoneNumber || '',
  // };

  // const handlers = {
  //   handleSettingDialogue: (handlerProps: DialogueHandlerProps<SettingDialogueHandler>) => {
  //     const { type: typeHandler, state: state2, action = 'default' } = handlerProps;

  //     const dialogueHandlers: SettingDialogueHandler = {
  //       confirm: {
  //         confirm: {
  //           default: () => {
  //             setShouldShowSettingAlert(false);
  //             setIsModalVisible(true);
  //           },
  //         },
  //         cancel: {
  //           default: () => {
  //             setShouldShowSettingAlert(false);
  //           },
  //         },
  //       },
  //     };
  //     const dialogueState = dialogueHandlers[typeHandler][state2];
  //     const handler = dialogueState ? dialogueState[action] || dialogueState.default : () => {};

  //     handler();
  //   },
  //   onEnablePortal: (_values: ClientAccountType) => {
  //     setClientAccountValues({
  //       EmailAddress: _values.EmailAddress,
  //       PhoneNumber: _values.PhoneNumber.replaceAll('+', ''),
  //     });
  //     setHasClientAccountValues(true);
  //   },
  // };

  // useEffect(() => {
  //   if (hasClientAccountValues) {
  //     if (
  //       clientAccountValues.PhoneNumber !== account.PhoneNumber ||
  //       clientAccountValues.EmailAddress !== account.EmailAddress
  //     ) {
  //       setShouldEnablePortal(true);
  //       postEditClientAccount({
  //         ClientAccountID: account.ClientAccountID,
  //         PhoneNumber: clientAccountValues.PhoneNumber,
  //         EmailAddress: clientAccountValues.EmailAddress,
  //       });
  //     } else {
  //       postEnableClientAccountPortal({
  //         ClientAccountID: account.ClientAccountID,
  //         PhoneNumber: clientAccountValues.PhoneNumber,
  //         Email: clientAccountValues.EmailAddress,
  //       });
  //       setIsModalVisible(false);
  //       setShouldShowToast(true);
  //     }
  //     setHasClientAccountValues(false);
  //   }
  // }, [clientAccountValues, hasClientAccountValues]);

  // useEffect(() => {
  //   if (shouldEnablePortal) {
  //     postEnableClientAccountPortal({
  //       ClientAccountID: account.ClientAccountID,
  //       PhoneNumber: clientAccountValues.PhoneNumber.replaceAll('+', ''),
  //       Email: clientAccountValues.EmailAddress,
  //     });
  //     history.push({
  //       pathname: `/client-accounts-list/details/${account.ClientAccountID}`,
  //       state: {
  //         editedPhoneNumber: clientAccountValues.PhoneNumber.replaceAll('+', ''),
  //       },
  //     });
  //     setIsModalVisible(false);
  //     setShouldEnablePortal(false);
  //     setShouldShowToast(true);
  //   }
  // }, [editClientAccount]);

  // useEffect(() => {
  //   if (shouldShowToast) {
  //     setShouldShowToast(false);
  //     setIsToastVisible(true);
  //     setIsPortalEnabled(true);
  //   }
  // }, [enableClientAccountPortal]);

  // useEffect(() => {
  //   const toastTimeout = setTimeout(() => {
  //     setIsToastVisible(false);
  //   }, 4000);
  //   return () => {
  //     clearTimeout(toastTimeout);
  //   };
  // }, [isToastVisible]);

  return (
    // hide cap enable section until cPortal is ready
    // <SettingContext.Provider value={settingDialogueContext}>
    //   <Modal isVisible={isModalVisible} enableBgClick={false}>
    //     <div className={styles.modalContainer}>
    //       <Box flx="col" gapSize="12px">
    //         <SubTitle subTitle="Confirm Client Account Credentials" fontSize="24px" center />
    //         <p>This client account will use this information to sign into the Client Account Portal.</p>
    //       </Box>

    //       <Formik
    //         initialValues={defaultValues}
    //         onSubmit={handlers.onEnablePortal}
    //         validationSchema={createdValidationSchema()}
    //         validateOnChange
    //         validateOnBlur
    //       >
    //         {({
    //           values,
    //           errors,
    //           touched,
    //           isValid,
    //           resetForm,
    //           handleChange,
    //           handleBlur,
    //           handleSubmit,
    //           setFieldValue,
    //         }) => {
    //           const [isButtonEnabled, setIsButtonEnabled] = useState(true);

    //           useEffect(() => {
    //             if (!isModalVisible) {
    //               resetForm();
    //               setIsButtonEnabled(true);
    //             }
    //           }, [isModalVisible]);

    //           useEffect(() => {
    //             const buttonEnabledCheck = isValid && isButtonEnabled;
    //             setIsButtonEnabled(buttonEnabledCheck);
    //           }, [values, errors]);

    //           useEffect(() => {
    //             if (Object.values(errors).length === 0) {
    //               setIsButtonEnabled(true);
    //             }
    //           }, [errors]);

    //           return (
    //             <form onSubmit={handleSubmit}>
    //               {editClientAccountRows.map(({ label, id, required, preset }) => (
    //                 <ElementContainer
    //                   key={id}
    //                   width="100%"
    //                   padding="24px 0 10px 0"
    //                   isBold={false}
    //                   label={
    //                     <>
    //                       {label} {required && <span className={styles.required}>*</span>}
    //                     </>
    //                   }
    //                   input={
    //                     preset !== 'tel' ? (
    //                       <div className={styles[getDisabledClass(required)]}>
    //                         <TextField
    //                           variant="lined"
    //                           name={id}
    //                           preset={preset}
    //                           value={values[id]}
    //                           disabled={!required}
    //                           borderColor={required ? '#C4C4C4' : '#EFEFEF'}
    //                           width="100%"
    //                           height="36px"
    //                           padding="0 12px"
    //                           onBlur={handleBlur}
    //                           onChange={handleChange}
    //                           error={errors[id] && touched[id] ? errors[id] : null}
    //                         />
    //                       </div>
    //                     ) : (
    //                       <PhoneInput
    //                         defaultCountry={account.Country === 'United States' ? 'US' : 'CA'}
    //                         id={id}
    //                         value={values[id]}
    //                         setFieldValue={setFieldValue}
    //                         setHasError={setIsButtonEnabled}
    //                         error={errors[id] ? errors[id] : null}
    //                       />
    //                     )
    //                   }
    //                 />
    //               ))}
    //               <div className={styles.formButtonContainer}>
    //                 <Button
    //                   id="cancel-edit-credential-button"
    //                   label="Cancel"
    //                   width="194px"
    //                   height="36px"
    //                   round
    //                   background="#FBFBFB"
    //                   onClick={() => {
    //                     setIsModalVisible(false);
    //                   }}
    //                 />
    //                 <Button
    //                   id="confirm-edit-credential-button"
    //                   label="Confirm"
    //                   width="194px"
    //                   height="36px"
    //                   round
    //                   isDisabled={!isButtonEnabled}
    //                   type="submit"
    //                 />
    //               </div>
    //             </form>
    //           );
    //         }}
    //       </Formik>
    //     </div>
    //   </Modal>

    <Box flx="col" gapSize="24px">
      <Card title="Default Language">
        <Box jc="sb">
          <Box>The primary language used to communicate with this client account.</Box>
          <Box jc="fe" pe="smd">
            <Radio
              name="client-account-language"
              varient="inline"
              value={lang || 'en'}
              options={{
                en: 'English',
                fr: 'Francais',
              }}
              readOnly
              onChange={() => {}}
            />
          </Box>
        </Box>
      </Card>

      {response.clientAccountsEnabled && (
        <>
          <Card title="Transaction Permissions">
            <Box jc="sb" ai="fe">
              <Box lineHeight="150%" maxwidth="50%">
                Send & Receive funds client accounts allow outbound and inbound transactions. Receive-Only Client
                Accounts are limited to inbound transactions.
              </Box>
              <Box jc="fe" pe="smd">
                <Radio
                  name="client-account-type"
                  varient="inline"
                  value={receiveOnly ? 'receiveOnly' : 'sendReceive'}
                  options={{
                    sendReceive: 'Send & Receive Funds',
                    receiveOnly: 'Receive-Only',
                  }}
                  noOrdering
                  readOnly
                  onChange={() => {}}
                />
              </Box>
            </Box>
          </Card>
          {/* <Box boundary="shadow" r="md" p="xmd" flx="col" gapSize="32px">
                  <SubTitle subTitle="Client Account Portal" fontSize="20px" variant="bold" />
                  <Box jc="sb" ai="fe">
                    <Box lineHeight="150%">Enable Client Account Portal for this Client Account.</Box>
                    {isPortalEnabled ? (
                      <Box gapSize="8px" ai="center">
                        <span className={styles.checkIcon}>
                          <Icon icon="check" width="13px" height="13px" />
                        </span>
                        Portal Enabled
                      </Box>
                    ) : (
                      <Button
                        id="enable-portal-button"
                        label="Enable Portal"
                        isDisabled={account.IsActive === '0'}
                        width="124px"
                        height="36px"
                        onClick={() => {
                          setShouldShowSettingAlert(true);
                        }}
                      />
                    )}
                  </Box>
                </Box> */}
        </>
      )}
    </Box>

    //   <Toast
    //     isVisible={isToastVisible}
    //     width="max-content"
    //     label={
    //       <>
    //         <b style={{ paddingRight: '4px' }}>Client Account Portal Enabled</b>Portal credentials have been sent to{' '}
    //         {account.ClientType === 'business'
    //           ? account.BusinessName || 'the client acccount'
    //           : `${account.FirstName} ${account.LastName}` || 'the client account'}
    //       </>
    //     }
    //     textColor="#2D2D2D"
    //     timerTime={5000}
    //     bottomPosition={isToastVisible ? '72px' : '-100px'}
    //   />
    //   <SettingDialogue handleDialogue={handlers.handleSettingDialogue} />
    // </SettingContext.Provider>
  );

  // function getDisabledClass(required: boolean) {
  //   return !required ? 'disabled' : '';
  // }

  // function createdValidationSchema() {
  //   return Yup.object().shape({
  //     ContactName: Yup.string(),
  //     EmailAddress: Yup.string().required('This information is required.').email('Please enter a valid Email Address'),
  //     PhoneNumber: Yup.string().required('This information is required.'),
  //   });
  // }
};
export default SettingsTab;
